<template>
  <div class="modal-wrap">
    <el-dialog title="自定义素材尺寸" lock-scroll :visible.sync="dialogVisible" width="463px" :close-on-click-modal="false">
      <div class="form-wrap">
        <el-table
          :data="list"
          style="flex: 1"
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.1)"
          ref="table"
          :max-height="600"
        >
          <el-table-column label="序号" prop="index" width="60"> </el-table-column>
          <el-table-column label="尺寸（宽*高）" prop="size">
            <template slot-scope="scope">
              <div v-if="editDataSet[scope.row.id]" style="display: flex">
                <el-input-number
                  v-model="editDataSet[scope.row.id].width"
                  :controls="false"
                  :max="99999"
                  :min="1"
                  class="input-area"
                  placeholder="请输入宽"
                  resize="none"
                >
                </el-input-number>
                <div style="line-height: 32px;margin: 0 6px;">*</div>
                <el-input-number
                  v-model="editDataSet[scope.row.id].height"
                  :controls="false"
                  :max="99999"
                  :min="1"
                  class="input-area"
                  placeholder="请输入高"
                  resize="none"
                >
                </el-input-number>
              </div>
              <div v-else class="show-text">
                <span>{{ scope.row.size }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="110">
            <template slot-scope="scope">
              <div v-if="editDataSet[scope.row.id]">
                <i class="el-icon-close" @click="cancelEdit(scope.row)"></i>
                <i class="el-icon-check" @click="saveEdit(scope.row)"></i>
              </div>
              <div v-else>
                <el-button class="delete-btn" type="text" @click="handleEdit(scope.row)">编辑</el-button>
                <el-button class="delete-btn" type="text" @click="handleDelete(scope.row)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer" @click="addproductGroup"><i class="el-icon-plus"></i> 新增尺寸</div>
    </el-dialog>
  </div>
</template>

<script>
import { geMaterialSizeList, addMaterialSize, delMaterialSize } from "@/api/materialManage.js";
export default {
  name: "TimeModal",
  data() {
    return {
      dialogVisible: false,
      loading: false,
      list: [],
      editDataSet: {},
      mode: "",
    };
  },
  methods: {
    getList() {
      this.editDataSet = {};
      geMaterialSizeList().then((res) => {
        this.list = res.data.map((item, index) => {
          item.index = index + 1;
          return item;
        });
      });
    },
    showModal() {
      this.getList();
      this.dialogVisible = true;
    },
    addproductGroup() {
      this.mode = "add";
      const newData = { index: this.list.length + 1, id: Math.random(), with: undefined, height: undefined };
      this.list.push(newData);
      this.$set(this.editDataSet, newData.id, newData);
    },
    handleEdit(row) {
      this.mode = "edit";
      const data = JSON.parse(JSON.stringify(row));
      data.width = data.size.split("*")[0];
      data.height = data.size.split("*")[1];
      this.$set(this.editDataSet, row.id, data);
    },
    cancelEdit(row) {
      if (this.mode === "edit") {
        this.$delete(this.editDataSet, row.id);
      } else {
        const index = this.list.findIndex((item) => item.id === row.id);
        this.list.splice(index, 1);
      }
    },
    saveEdit(row) {
      let curRow = this.list.find((item) => item.id === row.id);
      let reqData = Object.assign(JSON.parse(JSON.stringify(curRow)), this.editDataSet[row.id]);
      if (!reqData.width || !reqData.height) {
        this.$message({
          message: "尺寸内容缺失",
          type: "error",
        });
        return;
      }
      reqData.size = `${reqData.width}*${reqData.height}`;
      if (this.mode === "add") {
        delete reqData.id;
      }
      addMaterialSize(reqData).then((res) => {
        if (res.code === "0000") {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          Object.assign(curRow, this.editDataSet[row.id]);
          this.$delete(this.editDataSet, row.id);
          this.getList();
        }
      });
    },
    handleDelete(row) {
      this.$confirm("确定删除该自定义素材尺寸?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delMaterialSize({ id: row.id }).then((res) => {
            if (res.code === "0000") {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getList();
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.modal-wrap {
  /deep/ .el-dialog__title {
    font-weight: 500;
  }
  /deep/ .el-table {
    border-bottom: none;
  }
  .dialog-footer {
    width: 397px;
    height: 47px;
    border-radius: 0 0 4px 4px;
    background: rgba(251, 251, 251, 1);
    text-align: center;
    line-height: 47px;
    color: rgba(24, 144, 255, 1);
    margin-top: -24px;
    margin-left: -2px;
    border: 1px solid rgba(240, 240, 240, 1);
    border-top: none;
  }
  .el-icon-close {
    font-size: 18px;
    cursor: pointer;
  }
  .el-icon-check {
    margin-left: 12px;
    color: rgb(24, 144, 255);
    font-size: 18px;
    cursor: pointer;
  }
}
</style>
